export class NativeService {
  public static willShowPushContent(): void {
    this.sendMessage(
      JSON.stringify({
        "action": "willShowPushContent"
      })
    );
  }

  private static sendMessage(method: string): void {
    switch (window.platform) {
      case "ios":
        if (window.webkit !== undefined) {
          window.webkit.messageHandlers.app.postMessage(method);
        }
        break;
      case "android":
        if (window.android !== undefined) {
          window.android.postMessage(method);
        }
        break;
      default:
        console.log("This method is not support by your device");
        break;
    }
  }

  public static changeIcon(icon: string): void {
    this.sendMessage(
      JSON.stringify({
        "action": "changeIcon",
        "icon": icon
      })
    );
  }

  public static resetIcon(): void {
    this.sendMessage(
      JSON.stringify({
        "action": "resetIcon"
      })
    );
  }

  public static showPowerApp(url: string): void {
    this.sendMessage(
      JSON.stringify({
        "action": "showPowerApp",
        "url": url
      })
    );
  }

  public static hidePowerApp(): void {
    this.sendMessage(
      JSON.stringify({
        "action": "hidePowerApp",
      })
    );
  }

  public static hasCustomIcon(tenantName: string): boolean {
    return (
      tenantName === "hillerdforsyning" ||
      tenantName === "foodservicedk" ||
      tenantName === "lemangroup" ||
      tenantName === "davidsendk" ||
      tenantName === "aabnet" ||
      tenantName === "tcmail" ||
      tenantName === "harboes" ||
      tenantName === "energiviborgdk" ||
      tenantName === "kbintern" ||
      tenantName === "aakonline" ||
      tenantName === "mwblaw" ||
      tenantName === "stsmd" ||
      tenantName === "pro" ||
      tenantName === "mobelgroup" ||
      tenantName === "ambucloud" ||
      tenantName === "gladsaxe" ||
      tenantName === "fguoj" ||
      tenantName === "museumsonderjylland" ||
      tenantName === "naviair" ||
      tenantName === "asdal" ||
      tenantName === "ekj" ||
      tenantName === "bluecow" ||
      tenantName === "vikingbus" ||
      tenantName === "dge2014" ||
      tenantName === "abacusmedicine" ||
      tenantName === "fellowminddk" ||
      tenantName === "eurowind" ||
      tenantName === "novavi" ||
      tenantName === "greenhydrogensystems" ||
      tenantName === "danskboldspilunion" ||
      tenantName === "danskefamilieadvokater") &&
      window.platform === "ios";
  }

  public static ready(): void {
    this.sendMessage(
      JSON.stringify({
        "action": "ready"
      })
    );
  }

  public static getVersion(): void {
    this.sendMessage(
      JSON.stringify({
        "action": "getVersion"
      })
    );
  }
}

export default NativeService;